// base environment file, used for dev and production

export const base = {
    debug: false,
    production: false,
    staging: false,
    dev: false,
    routes: false,
    baseUrl: 'https://digi.schule.local',
    mediaBaseURL: (quicklink) => {
        return `https://m.digi.schule/${quicklink}/content/media/`;
    },
    readSpeaker: {
        baseUrl: 'https://app-eu.readspeaker.com/cgi-bin/rsent',
        voiceDE: 'Klara',
        voiceEN: 'Alice',
        customerId: 7816
    },
    endpointUrls: {
        pages: 'bookDataPages',
        chapters: 'bookDataChapters',
        interactiveTaskTypes: 'bookDataInteractiveTasksTypes',
        interactiveTasks: 'bookDataInteractiveTasks',
        interactiveQuestions: 'bookDataInteractiveQuestions',
        linkTypes: 'bookDataLinksTypes',
        links: 'bookDataLinks',
        bookConfig: 'bookDataConfig',
        pageFavorites: 'bookDataPageFavorites',
        audios: 'bookDataBookAudios',
        videos: 'bookDataBookVideos',
        rects: 'bookDataRects',
        noteExport: 'bookDataRectsExport',
        portfolioIndividual: 'userDataGetPortfolioIndividualData',
        readspeakerElements: 'bookDataPageTexts',
        verifyInteractiveTask: 'bookDataInteractiveTasksVerify',
        readspeakerTextUrl: 'bookDataPageTextsRead',
        readspeakerPreviewUrl: 'bookDataPageTextsPreview',
        testQuickLinks: 'bookDataQuickLinksTest',
        quickLinks: 'bookDataQuickLinks',
        quicklink: 'hsmAssignment',
        textSelections: 'bookDataTextSelections',
        bookAdditionals: 'bookDataAdditionals',
        bookAdditionalTypes: 'bookDataAdditionalsTypes',
        usedBooks: 'userDataBooksUsed',
        usedMaterials: 'userDataAdditionalsUsed',
        schoolBagFiles: 'userDataSchoolbagFiles',
        exportPDF: 'bookDataExportPdf',
        userData: 'userDataInfo',
        downloadPages: 'digibookDownloadPages',
        offlineModeCreate: 'bookDataOfflineVersionCreate',
        offlineModeCheck: 'bookDataOfflineVersionCheck',
        logUsage: 'bookDataFeatureUsageLog',
        quicklinkSign: 'bookDataESquirrelSign',
        siaSign: 'bookDataSiaSign',
        bookFeatures: 'bookDataFeatures',
        pageDrawings: 'bookDataPageDrawings',
        quicklinkSignESQUIRREL: 'bookDataESquirrelSign',
        quicklinkSignGMT: 'bookDataGMTSign',
        quicklinkSignEduvidual: 'bookDataEduvidualSign',
        quicklinkSignYedo: 'bookDataYedoSign',
        quicklinkSignPhase: 'bookDataPhaseSign',
        pageSearch: 'bookDataPageTextsSearch',
        quickLinkExtendSearch: 'bookDataPageTextQuickLinksSearchExtended',
        hsmLinksSearch: 'bookDataPageTextHSMLinks',
        quickLinkSearch: 'bookDataPageTextQuickLinksSearch',
        quickLinkBookSearch: 'bookDataQuicklinkBooks',
        hsmLinksBooks: 'bookDataHsmLinksBooks',
        hsmLinks: 'userDataHsmLinks',
        hsmDownloadEvaluation: 'hsmDownloadEvaluation',
        hsmFrame: 'hsmShowQuicklink',
        dictionary: 'bookDataDictionarySearch',
        bookAccessCode: 'userDataActivateBookAccessCode',
        startTrial: 'access-code.start-trial',
        hsmSaveHomework: 'hsmCreateHomework',
        hsmEditHomework: 'hsmEditHomework',
        hsmDeleteHomework: 'hsmDeleteHomework',
        hsmSendHomeworkEmail: 'hsmSendHomeworkEmail',
        exportPdf: 'rest.export.pdf',
        bookSeries: 'bookDataBookSeries',
        profileRoute: 'getProfile',
        contactRoute: 'contact',
        bookAccessCodeReset: 'customer.codes.resetView',
        recommendations: 'bookDataPageTextQuickLinksSearchRecommendations',
        whiteboardDrawingList: 'bookDataWhiteboardDrawings',
        whiteboardDrawingCreate: 'bookDataWhiteboardDrawingsCreate',
        whiteboardDrawingUpdate: 'bookDataWhiteboardDrawingsUpdate',
        whiteboardDrawingDelete: 'bookDataWhiteboardDrawingsDelete',
        whiteboardDrawingDownload: 'bookDataWhiteboardDrawingsDownload',
        schoolClassList: 'rest.schoolClass.list',
        schoolClassNotify: 'rest.schoolClass.notify',
        schoolTypesList: 'rest.listSchoolTypes',
        schoolSubjectsList: 'rest.listSubjects',
        userBookAccessCodes: 'customer.access-codes.all',
        userUseAccessCode: 'customer.access-codes.used',
        assignmentLink: 'https://m.digi.schule',
        bookAssetsCover: 'book-assets.cover',
        bookInformations: 'book-assets.information',
        userPermissions: 'user.permissions',
        quicklinkSignCalcuflow: 'book-data.sign.calcuflow',
        pageTexts: 'pageTexts',
        quickLinkRedirectCreate: 'quick-link-redirect.create',
        hsmLoggingQueue: 'rest.queue.hsm-queue.add',
        worksheetGet: 'rest.worksheet.get',
        worksheetCreate: 'rest.worksheet.create',
        worksheetEdit: 'rest.worksheet.edit',
        worksheetDelete: 'rest.worksheet.delete',
        ltiLaunch: 'book-data.sign.launch',
        codeUpgrade: 'customer.access-codes.upgrade',
        queue: {
            log: 'rest.queue.hsm-queue.add',
            error: 'rest.queue.hsm-queue.add'
        },
        navigation: 'hsmNavigation',
        mail: 'https://m.digi.schule/mailRelay.php?sofa=1',
        log: 'https://m.digi.schule/loggingRelay.php?sofa=1',
        actor: 'hsm-data.actor-token',
        actorRelay: 'https://m.digi.schule/actorRelay.php?sofa=1',
        logError: 'https://m.digi.schule/content/log.php?sofa=1',
        errorReport: 'hsm-data.error-report',
        translation: 'https://m.digi.schule/translationRelay.php?sofa=1',
        readSpeaker: 'hsmRead',
        hsmMatheditorDownload: 'userDataHsmMatheditorDownload',
        portfolioDataUrl: 'userDataGetPortfolioData',
        saveAssignmentToken: 'saveAssignmentToken',
        userIdentify: {
            create: 'user.identify.create'
        },
        glossary: 'rest.glossary.index',
        bookCoverUrl: 'book-assets.cover',
        externalLTI: 'lti-default.external',
        qrCodeGenerator: 'rest.utils.qr-code.generate',
        quickLinkSignEduSuite: 'rest.edu-suite.sign',
        quickLinkSignMathion: 'rest.mathion.sign'
    },
    puppeteerDomain: 'https://digi-schule.dev.staging.sofamedia.at',
    internalUrls: {
        schoolbag: 'schoolbag',
        copyBook: 'digibookCopyBook'
    },
    externalUrls: {
        preview: (quicklink: string) => {
            return `https://m.digi.schule/${quicklink}/content/images/preview.jpg`;
        },
        img: (filename: string, quicklink: string) => {
            return `https://m.digi.schule/${quicklink}/content/images/${filename}`;
        }
    },
    crudEndpointsPostfixes: {
        create: 'Create',
        update: 'Save',
        remove: 'Delete'
    },
    assetsBasePath: 'assets/js/bookviewer/assets',
    assetsAbsoluteUrls: true,
    readspeakerBaseUrl: 'https://app-eu.readspeaker.com/cgi-bin/rsent',
    mBookUrl: 'https://mbook.staging.sofamedia.at/',
    readspeakerVoiceDE: 'Klara',
    readspeakerVoiceEN: 'Alice',
    readspeakerCustomerId: 7816,
    quickLinkFilter: [
        'digi.schule/',
        'digi.schule.local/',
        'digi.study/',
        'digischule.at/',
        'digi.schule.local/',
        'digischule.local/',
        'digi-schule.staging.sofamedia.at/',
        'digischule.staging.sofamedia.at/',
        'digi-schule.dev.staging.sofamedia.at/'
    ],
    platformDomains: [
        'digi.schule',
        'digi.study',
        'digi-schule.staging.sofamedia.at',
        'digischule.at',
        'digischule.local',
        'digischule.staging.sofamedia.at'
    ],
    minZoomLevel: 1,
    maxZoomLevel: 3,
    amountZoomLevels: 70,
    mobileBreakPoint: 767,
    scrollBarSize: 16,
    features: {
        readspeakerActivated: true,
        rectsActivated: true,
        textSelectionActivated: true,
        schoolBagActivated: true,
        exportPagesActivated: true,
        linksActivated: true,
        quickLinksActivated: true,
        audiosActivated: true,
        videosActivated: true,
        interactiveTasksActivated: true,
        bookAdditionalsActivated: true,
        bookFavoritesActivated: true,
        offlineModeActivated: true,
        pageDrawingsActivated: true,
        hsmListActivated: true,
        newHsmActivated: true,
        dictionaryActivated: true
    },
    searchBorders: {
        exercises: {
            min: 1,
            max: 4
        },
        texts: {
            min: 3,
            max: Number.MAX_SAFE_INTEGER
        }
    },
    viewModes: {
        defaultViewMode: {
            slug: 'default',
            pagesToShow: 2,
            imagesToPreload: 2,
            showTopbar: true,
            showFooter: true,
            showZoom: true,
            showPageTurner: true,
            widthOfSidebar: 280,
            maxZoomLevel: 3
        },
        defaultMobile: {
            slug: 'default',
            pagesToShow: 1,
            imagesToPreload: 6,
            showTopbar: true,
            showFooter: true,
            showZoom: true,
            showPageTurner: false,
            widthOfSidebar: 280,
            maxZoomLevel: 3
        },
        presentationViewMode: {
            slug: 'presentation',
            pagesToShow: 2,
            imagesToPreload: 6,
            showTopbar: true,
            showFooter: true,
            showZoom: true,
            showPageTurner: true,
            widthOfSidebar: 280,
            maxZoomLevel: 3
        },
        scrollViewMode: {
            slug: 'scroll',
            pagesToShow: 1,
            imagesToPreload: 5,
            showTopbar: true,
            showFooter: true,
            showZoom: true,
            showPageTurner: false,
            widthOfSidebar: 280,
            maxZoomLevel: 3
        }
    },
    colorConfig: {
        background: {
            intro: '#e3ecfa',
            assignment: '#f5f2f2',
            check: '#F5EBF7',
            topic: '#EBE7E2'
        },
        complexityBackground: {
            1: '#dbed9a',
            2: '#ffe0ce',
            3: '#fff4e2',
            4: '#ffe0e6',
            intro: '#4589C3',
            assignment: '#f5f2f2',
            check: '#995E98',
            topic: '#73805C'
        },
        complexityText: {
            1: '#8d9b57',
            2: '#ffab20',
            3: '#ff5c00',
            4: '#e4032e',
            intro: '#fff',
            assignment: '#7B8568',
            check: '#fff',
            topic: '#fff'
        }
    }
};
